import React, { useEffect, useState } from 'react';
import { Avatar, useChatContext } from 'stream-chat-react';

import { InviteIcon } from '../assets';

const ListContainer = ({children}) => { //whatever comp we render inside this will be populated into the children prop 
    return (
        <div className="user-list__container">
            <div className="user-list__header">
                <p>User</p>
                <p>Invite</p>
            </div>
            {children}
        </div>
    )
}

const UserItem = ({user, setSelectedUsers}) => {
    const [selected, setSelected] = useState(false);

    const handleSelect = () => {
        if(selected) {
            setSelectedUsers((prevUsers) => prevUsers.filter((prevUser) => prevUser !== user.id)) //this will filter out the currently clicked item if it was clicked
        } else {
            setSelectedUsers((prevUsers) => [...prevUsers, user.id]) //this will add one more user
        }

        setSelected((prevSelected) => !prevSelected); 
        /*this is how toggle between 2 states on react(selected and not selected).
        But this will just enable us to toggle for only one user. If we toggle for another user- it'll just unselect itself from the current user*/
    }

    return (
        <div className="user-item__wrapper" onClick={handleSelect}>
            <div className="user-item__name-wrapper">
                {/** These are the avatar and name of the users we're inviting */}
                <Avatar image={user.image} name={user.fullName || user.id} size={32} /> {/* extracting avatar of the specific user by mapping */}
                <p className="user-item__name">{user.fullName || user.id}</p>
            </div>
            {/* This inviteicon is nothing but the green check mark next to selected users for inviting.
            If user is selected, then invite icon will be displayed next to it. 
            Else user-item__invite-empty (empty check mark) will be displayed. We can toggle between them*/}
            {selected ? <InviteIcon /> : <div className="user-item__invite-empty" />} 

        </div>
    )
}

const UserList = ({ setSelectedUsers }) => {
    const { client } = useChatContext(); //extracting the clients by making use of useChatContext
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [listEmpty, setListEmpty] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const getUsers = async () => {
            if(loading) return;

            setLoading(true);
            
            try {
                const response = await client.queryUsers(
                    { id: { $ne: client.userID } }, //we're just filtering out ourselves from the result. $ne means not equal to
                    { id: 1 },
                    { limit: 8 } 
                );

                if(response.users.length) {
                    setUsers(response.users);
                } else {
                    setListEmpty(true);
                }
            } catch (error) {
               setError(true);
            }
            setLoading(false);
        }

        if(client) getUsers() //if we get any clients as result, only then get the results
    }, []);

    if(error) {
        return (
            <ListContainer>
                <div className="user-list__message">
                    Error loading users, please refresh and try again.
                </div>
            </ListContainer>
        )
    }

    if(listEmpty) {
        return (
            <ListContainer>
                <div className="user-list__message">
                    No users found.
                </div>
            </ListContainer>
        )
    }

  return (
        <ListContainer>
             {loading ? <div className="user-list__message">
                Loading users...
            </div> : (
                users?.map((user, i) => ( //If everything works out, then this will render out the avatar and the username of users
                  <UserItem index={i} key={user.id} user={user} setSelectedUsers={setSelectedUsers} />  
                ))
            )}
        </ListContainer>
        );
};

export default UserList;
